import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { logout } from "../../../redux/features/auth-slice";
import { toAbsoluteUrl } from "../../../_metronic/helpers";

type Props = {
	show: boolean;
}

const SessionExpiredModal = ({ show }: Props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const styles = show ? { display: 'block' } : { display: 'none' };

	const onConfirm = () => {
		dispatch(logout());
	}

	return (
		<div
			className={`modal animate__animated animate__fadeIn ${show ? 'show four' : ''}`}
			tabIndex={-1}
			id="session-expired-modal"
			style={styles}
		>
			<div className="modal-dialog modal-dialog-centered animate__animated animate__faster animate__zoomIn">
				<div className="modal-content bg-light-danger radius-12px">
					<div className="modal-body mx-auto" style={{ padding: "30px 60px 25px" }}>
						<img alt='Logo' src={toAbsoluteUrl('/media/logos/session.png')} className='h-80px' />
						<h5 className="fw-bolder text-center fs-1 mb-5">{t('session_expired')}</h5>
						<h5
							className="modal-title text-center text-gray-900 mb-5"
							style={{
								fontSize: "14px",
								fontWeight: 400,
								fontStyle: "normal",
							}}
						>
							{t('session_expired_msg')}
						</h5>
						{/* <div className="separator separator-dashed border-danger opacity-25"></div> */}
						<div className="d-flex flex-center flex-wrap">
							<button
								type="button"
								className="btn btn-danger w-125px rounded-pill"
								style={{ margin: "0px", fontSize: "13.5px" }}
								data-bs-dismiss="modal"
								onClick={onConfirm}
							>
								{t('refresh')}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export { SessionExpiredModal };
